import { Link } from "react-router-dom";
import { ArrowLeft } from "lucide-react";
import { Helmet } from "react-helmet-async";
import Navbar from "@/components/Navbar";
import FooterSection from "@/components/FooterSection";

const TermsOfService = () => (
  <>
    <Helmet>
      <title>Terms of Service | Zenith Solutions</title>
      <meta name="description" content="Zenith Solutions terms of service. Review our terms and conditions for using our website and services." />
    </Helmet>
    <Navbar />
    <div className="min-h-screen bg-background">
      <div className="container mx-auto max-w-3xl px-4 pt-28 pb-20">
        <Link to="/" className="inline-flex items-center gap-1.5 text-sm font-medium text-primary hover:text-primary/80 mb-8">
          <ArrowLeft className="h-4 w-4" /> Back to Home
        </Link>

        <h1 className="text-3xl md:text-4xl font-black text-foreground mb-2">Terms of Service</h1>
        <p className="text-muted-foreground mb-10">Last updated: February 20, 2026</p>

        <div className="prose prose-sm max-w-none text-foreground/90 space-y-8">
          <section>
            <h2 className="text-xl font-bold text-foreground">1. Acceptance of Terms</h2>
            <p className="text-muted-foreground leading-relaxed">
              By accessing and using the Zenith Solutions website, you accept and agree to be bound by these Terms of Service. If you do not agree to these terms, please do not use our website.
            </p>
          </section>

          <section>
            <h2 className="text-xl font-bold text-foreground">2. Services</h2>
            <p className="text-muted-foreground leading-relaxed">
              Zenith Solutions provides roofing, general construction, and solar installation services in New Mexico. All services are subject to a separate service agreement that will be provided before work begins.
            </p>
          </section>

          <section>
            <h2 className="text-xl font-bold text-foreground">3. Estimates & Pricing</h2>
            <p className="text-muted-foreground leading-relaxed">
              All estimates provided through our website or in person are free and non-binding. Final pricing will be detailed in a written service agreement. Prices may vary based on the scope of work, materials, and project requirements.
            </p>
          </section>

          <section>
            <h2 className="text-xl font-bold text-foreground">4. Website Use</h2>
            <p className="text-muted-foreground leading-relaxed">You agree to use our website only for lawful purposes. You may not:</p>
            <ul className="list-disc pl-6 text-muted-foreground space-y-1">
              <li>Use the website in any way that violates applicable laws or regulations</li>
              <li>Attempt to gain unauthorized access to any part of the website</li>
              <li>Submit false or misleading information through our contact forms</li>
              <li>Use automated tools to scrape or collect data from the website</li>
            </ul>
          </section>

          <section>
            <h2 className="text-xl font-bold text-foreground">5. Intellectual Property</h2>
            <p className="text-muted-foreground leading-relaxed">
              All content on this website, including text, images, logos, and design elements, is the property of Zenith Solutions and is protected by copyright and trademark laws. You may not reproduce, distribute, or use any content without our written permission.
            </p>
          </section>

          <section>
            <h2 className="text-xl font-bold text-foreground">6. Limitation of Liability</h2>
            <p className="text-muted-foreground leading-relaxed">
              Zenith Solutions shall not be liable for any indirect, incidental, or consequential damages arising from the use of our website or services. Our total liability shall not exceed the amount paid for the specific service in question.
            </p>
          </section>

          <section>
            <h2 className="text-xl font-bold text-foreground">7. Warranties</h2>
            <p className="text-muted-foreground leading-relaxed">
              All warranties for roofing, construction, and solar services will be detailed in your individual service agreement. Manufacturer warranties are subject to the terms set by the respective manufacturers.
            </p>
          </section>

          <section>
            <h2 className="text-xl font-bold text-foreground">8. Governing Law</h2>
            <p className="text-muted-foreground leading-relaxed">
              These Terms of Service are governed by and construed in accordance with the laws of the State of New Mexico, without regard to conflict of law principles.
            </p>
          </section>

          <section>
            <h2 className="text-xl font-bold text-foreground">9. Changes to Terms</h2>
            <p className="text-muted-foreground leading-relaxed">
              We reserve the right to modify these Terms of Service at any time. Changes will be effective immediately upon posting to this page. Your continued use of the website constitutes acceptance of the updated terms.
            </p>
          </section>

          <section>
            <h2 className="text-xl font-bold text-foreground">10. Contact Us</h2>
            <p className="text-muted-foreground leading-relaxed">
              If you have questions about these Terms of Service, please contact us at:
            </p>
            <p className="text-muted-foreground">
              <strong className="text-foreground">Zenith Solutions</strong><br />
              Albuquerque, NM<br />
              Phone: (505) 604-8536<br />
              Email: info@zenithsolutionsnm.com
            </p>
          </section>
        </div>
      </div>
    </div>
    <FooterSection />
  </>
);

export default TermsOfService;
